import moment from 'moment'
import { DatePicker } from 'antd'
import Select from 'react-select'
import pluralize from 'pluralize'
import React, { useState } from 'react'
import { Switch, Route, Link } from 'react-router-dom'

import { stringifyDate, useListData, presets } from '../../modules'

import Receive from "../../components/reusable/receive"
import SingleItemRequest from '../../components/modals/singleItemRequest'
import IssueSingleRequest from '../../components/modals/issueSingleRequest'

const { RangePicker } = DatePicker

const StoreRequests = ({ store }) => {
    const [sString, setSString] = useState('')
    const [classif, setClass] = useState({ label: 'All', value: 'All' })
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])
    
    const [
        { loading, error, fetch },
        { list: requests },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('requestsByStore', ranges ? {
        store: store?._id,
        type: "Received",
        classif: classif?.value,
        string: sString,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null
    } : {
        store: store?._id,
        type: "Received",
        classif: classif?.value,
        string: sString
    }, { notify: true }, 'requests')

    const refresh = resetNav => {
        if (resetNav)
            navigate(1)

        fetch()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const changeClassif = val => {
        setClass(val)
        refresh()
    }

    const searchSent = str => {
        setSString(str)
        if (str?.trim()?.length > 2 || !str) {
            setSString(str)
            refresh(true)
        }
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" />
                <div className="flex items-center justify-between w-full">
                    <input
                        onChange={e => searchSent(e.target.value)}
                        value={ sString }
                        className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-ssearch"
                        type="text"
                        placeholder="Evans Kimani" />
                    <span className="flex">
                        <Select
                            value={classif}
                            className="mr-2"
                            onChange={ changeClassif }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ ['All', 'Pending', 'Seen'].map(cls => ({ label: cls, value: cls })) }
                            placeholder="Viewed Status" />
                        <RangePicker value={ ranges } onChange={ selectRange } ranges={ presets } />
                    </span>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Store Requests</h2>
                </header>
                <div className="p-3">
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                requests.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Requested By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Sent From</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                requests.map((request, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{request?.requestedBy?.name}</div>
                                                            <p className="text-gray-500 text-xs italic">{request.requests.length} {pluralize('items', request.requests.length)}</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ request?.source?.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ request?.requests?.every(req => req?.issued) ? 'text-green-500' : request?.requests?.every(req => req?.discarded) ? 'text-gray-500' : request.seen ? 'text-blue-600' : 'text-yellow-500' }>{request?.requests?.every(req => req?.issued) ? 'Issued' : request.seen ? 'Seen' : 'Pending'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ stringifyDate(request.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Link to={ `/app/store/store-requests/requests/${store?._id}/${request._id}${request.issued ? '' : '/issue'}` }>
                                                                <button className={ `text-white ${ request?.requests?.every(req => req?.issued) ? 'hisani-btn-green-light' : request?.requests?.every(req => req.discarded) ? 'bg-gray-600' : request.seen ? 'bg-blue-600' : 'hisani-btn-orange-light' } font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center` }>View</button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } have been sent to { store?.name }</h2>
                                    </div>
                            }
                        </Receive>
                        { Paginate }
                    </div>
                </div>
            </div>
            <Switch>
                <Route exact path="/app/store/store-requests/requests/:id/:rq">
                    <SingleItemRequest path="/app/store/store-requests" onPerform={ refresh } />
                </Route>
                <Route path="/app/store/store-requests/requests/:id/:rq/issue">
                    <IssueSingleRequest path="/app/store/store-requests" onPerform={ refresh } />
                </Route>
            </Switch>
        </div>        
    )

}

export default StoreRequests